module.exports = function anonymous(locals, filters, escape, rethrow) {
    escape = escape || function(html) {
        return String(html).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    };
    var __stack = {
        lineno: 1,
        input: "<% if (filter.get('enabled')) { %>\n    <% if (filter.get('active')) { %>\n        <div class=\"filter_element\" style=\"background: <%= filter.get('colorCode') %>\">\n            <span class=\"filter active\"><%= filter.get('name') %></span>\n        </div>\n    <% } else { %>\n        <div class=\"filter_element\">\n            <span class=\"filter\" style=\"border-left: 4px solid <%= filter.get('colorCode') %>\"><%= filter.get('name') %></span>\n        </div>\n    <% } %>\n<% } %>",
        filename: "."
    };
    function rethrow(err, str, filename, lineno) {
        var lines = str.split("\n"), start = Math.max(lineno - 3, 0), end = Math.min(lines.length, lineno + 3);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    }
    try {
        var buf = [];
        with (locals || {}) {
            (function() {
                buf.push("");
                __stack.lineno = 1;
                if (filter.get("enabled")) {
                    buf.push("\n    ");
                    __stack.lineno = 2;
                    if (filter.get("active")) {
                        buf.push('\n        <div class="filter_element" style="background: ', escape((__stack.lineno = 3, filter.get("colorCode"))), '">\n            <span class="filter active">', escape((__stack.lineno = 4, filter.get("name"))), "</span>\n        </div>\n    ");
                        __stack.lineno = 6;
                    } else {
                        buf.push('\n        <div class="filter_element">\n            <span class="filter" style="border-left: 4px solid ', escape((__stack.lineno = 8, filter.get("colorCode"))), '">', escape((__stack.lineno = 8, filter.get("name"))), "</span>\n        </div>\n    ");
                        __stack.lineno = 10;
                    }
                    buf.push("\n");
                    __stack.lineno = 11;
                }
                buf.push("");
            })();
        }
        return buf.join("");
    } catch (err) {
        rethrow(err, __stack.input, __stack.filename, __stack.lineno);
    }
}


//////////////////
// WEBPACK FOOTER
// /home/app/terminal/release/1715684793-2.1.11/node_modules/ejs-compiled-loader!./src/templates/header_filter.ejs
// module id = 132
// module chunks = 0